var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.url && _vm.label
    ? _c(
        "a",
        {
          staticClass: "c-btn c-btn--margins",
          class: {
            "c-btn--primary": _vm.buttonType === "primary",
            "c-btn--secondary": _vm.buttonType === "secondary",
            "c-btn--tertiary": _vm.buttonType === "tertiary"
          },
          attrs: {
            href: _vm.url,
            alt: _vm.alt,
            target: _vm.linkTarget,
            tabindex: "0"
          },
          on: { click: _vm.registerEvent }
        },
        [_vm._v("\n  " + _vm._s(_vm.label) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }